import { ModalBaseProps } from '@round/ui-kit';
import { FullscreenModal } from '@round/whitelabel-ui';
import UserAudienceBreakdown from 'Modules/Plans/User/UserModal/components/Audience/UserAudienceBreakdown';
import HeadlineStats from 'Modules/Plans/User/UserModal/components/HeadlineStats/HeadlineStats';
import AccountDetail, { AccountDetailProps } from 'Modules/Plans/User/UserModal/components/AccountDetail/AccountDetail';
import { useTiktokUserAnalytics } from 'Modules/Influencer/hooks/queries/useTiktokUserAnalytics';
import { useTikTokUserImages, useTikTokUserStatsCache, useTiktokUser } from '@round/platforms/tiktok';

type Props = Pick<ModalBaseProps, 'isOpen' | 'onClose'> & {
    userId: number | null;
};

const TiktokUserModal = ({ isOpen, onClose, userId }: Props) => {
    const analytics = useTiktokUserAnalytics(userId, { select: (data) => data.data });
    const statsCache = useTikTokUserStatsCache(
        { user_id: typeof userId === 'number' ? [userId] : [] },
        { enabled: typeof userId === 'number' }
    );
    const statsCacheRow = statsCache.data?.results.find((s) => s.user_id === userId) ?? null;
    const tiktokUser = useTiktokUser(userId);
    const userImages = useTikTokUserImages(typeof userId === 'number' ? [userId] : []);
    const userImage = userImages.data?.find((img) => img.user_id === userId);

    const accountDetailProps: AccountDetailProps = {
        platform: 'tiktok',
        isAccountDataLoading: tiktokUser.isLoading || userImages.isLoading,
        isUserStatsCacheLoading: statsCache.isLoading,
        userImage: userImage?.avatar_thumb?.cached_url || userImage?.avatar_thumb?.original_url,
        userHandle: tiktokUser.data?.unique_id,
        username: tiktokUser.data?.nickname,
        bio: tiktokUser.data?.signature,
        location: statsCacheRow?.location,
        onClose: onClose,
    };

    return (
        <FullscreenModal isOpen={isOpen} onClose={onClose} closeOnOverlayClick closeOnEscape>
            <AccountDetail {...accountDetailProps} />
            <HeadlineStats data={statsCacheRow} isLoading={statsCache.isLoading} />
            <UserAudienceBreakdown
                data={analytics.data}
                isLoading={analytics.isLoading}
                errorMessage={analytics.errorMessage}
            />
        </FullscreenModal>
    );
};

export default TiktokUserModal;
